// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__2nYaM","noInteraction":"EventWrapper_noInteraction__Bjq4r","pointerPassthrough":"EventWrapper_pointerPassthrough__339rc"};